import React from "react";
import Query from "react-apollo/Query";
import { Mutation } from "react-apollo";
import { GET_USER_STEAKING, CREATE_STEAKING, GET_CURRENT_STEAKING } from "../../../queries";

import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import ArnoGold from "../../../img/IndexMain/arty-gold.png";
import check from "../../../img/IndexMain/check.svg";
import ArnoBronze from "../../../img/IndexMain/arty-bronze.png";
import ArtySilver from "../../../img/IndexMain/arty-silver.png";
import ArtyGold from "../../../img/IndexMain/arty-gold.png";
import { stakingLang } from "./stakingLang";
import ModalSteak from "./ModalSteak";

class Steaking extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deposit: 0,
            hover: false,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
            steakid: "",
            ModalShow: false,
        };
    }

    ChangeElement = event => {
        let value = event.target.value.replace(/[^1234567890.]/g, '');
        this.setState({deposit : value});
    };

    createSteakingEvent = (event, createSteaking) => {
        event.preventDefault();        
        createSteaking().then(({ data }) => {
            console.log(data.createSteaking);
            //this.props.refetch();
            window.open(`https://launch.artyfact.game/staking/`, '_top');
        })
    }; 

    handleMouseIn() {
        this.setState({ hover: true })
    }
      
    handleMouseOut() {
        this.setState({ hover: false })
    }

    CloseModal = event => {
        this.setState({ ModalShow: false });
    }

    OpenModal = (event, id) => {
        this.setState({ ModalShow: true, steakid: id });
    }
    
    render() {
        let self = this;
        let AvailableTokens = this.props.TokenAmount.availableToken.toFixed(2) >= 0 ? this.props.TokenAmount.availableToken.toFixed(2) : 0;
        let CanSteak = false; //this.state.deposit <= this.props.session.Balance && this.state.deposit <= 10000 && this.state.deposit != 0 && this.state.deposit >= 1000 ? true : false;
        const tooltipStyle = {
            display: this.state.hover ? 'block' : 'none'
        }
        return (
            <>
            <div className="WithdrawalPage">                
                <TopPafeInfo session={this.props.session} />

                <div className="StandartPartMain">
                    <div className="PersonalPageMainPersonalInformation StandartBigElement">
                        <div class="IndexMainElementIn">
                            <div class="StandartElementTitle">{stakingLang.title2[this.state.Language]}</div>
                            <div class="StandartElementTopBorder"></div>
                        </div>

                        <div className="MarketPageWithdrawalMoneyIn MarketPageWithdrawalMoneyIn02">
                            <div class="row" style={{width: '100%'}}>
                                <div class="col-md-4">
                                    <div class="package-area2">
                                        <img className="staking-img" src={ArnoBronze} />
                                        <div className="staking-ttl1">{stakingLang.title2[this.state.Language]}</div>
                                        <div className="staking-ttl2">{stakingLang.increase[this.state.Language]}</div>
                                        <div className="staking-ttl3">{stakingLang.year1[this.state.Language]}</div>
                                        <div className="staking-ttl4">{stakingLang.profit[this.state.Language]} 25%</div>
                                        <div className="staking-ttl3">{stakingLang.apr[this.state.Language]} 25%</div>
                                        <ul class="list-package" style={{width: '240px'}}>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.minimum[this.state.Language]} 1,000 $ARTY
                                            </li>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.maximum[this.state.Language]} 10,000 $ARTY
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="package-area2">
                                        <img className="staking-img" src={ArtySilver} />
                                        <div className="staking-ttl1">{stakingLang.title2[this.state.Language]}</div>
                                        <div className="staking-ttl2">{stakingLang.multiply[this.state.Language]}</div>
                                        <div className="staking-ttl3">2 {stakingLang.years[this.state.Language]}</div>
                                        <div className="staking-ttl4">{stakingLang.profit[this.state.Language]} 100%</div>
                                        <div className="staking-ttl3">{stakingLang.apr[this.state.Language]} 50%</div>
                                        <ul class="list-package" style={{width: '240px'}}>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.minimum[this.state.Language]} 1,000 $ARTY
                                            </li>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.maximum[this.state.Language]} 10,000 $ARTY
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="package-area2">
                                        <img className="staking-img" src={ArtyGold} />
                                        <div className="staking-ttl1">{stakingLang.title2[this.state.Language]}</div>
                                        <div className="staking-ttl2">{stakingLang.maximize[this.state.Language]}</div>
                                        <div className="staking-ttl3">3 {stakingLang.years[this.state.Language]}</div>
                                        <div className="staking-ttl4">{stakingLang.profit[this.state.Language]} 300%</div>
                                        <div className="staking-ttl3">{stakingLang.apr[this.state.Language]} 100%</div>
                                        <ul class="list-package" style={{width: '240px'}}>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.minimum[this.state.Language]} 1,000 $ARTY
                                            </li>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.maximum[this.state.Language]} 10,000 $ARTY
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="PersonalPageMain StandartPartMain">
                    <div className="PersonalPageMainPersonalInformation StandartBigElement">
                        <div class="IndexMainElementIn">
                            <div class="StandartElementTitle">{stakingLang.title[this.state.Language]}</div>
                            <div class="StandartElementTopBorder"></div>
                        </div>

                        <div className="MarketPageWithdrawalMoneyIn MarketPageWithdrawalMoneyIn02">
                             {/*<div class="row" style={{width: '100%'}}>
                               <div class="col-md-4">
                                    <div class="ico-round br1px">
                                        <div class="ico-r-ttl">All Staking tokens:</div>
                                        <div class="ico-r-cost">{this.props.TokenAmount.allToken} $ARTY</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="ico-round">
                                        <div class="ico-r-ttl">{stakingLang.available[this.state.Language]}</div>
                                        <div class="ico-r-cost">{/*{AvailableTokens}*/} {/*{this.props.session.Balance} $ARTY</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="ico-round">
                                        <div class="ico-r-ttl">{stakingLang.profit[this.state.Language]}:</div>
                                        <div class="ico-r-cost">{this.props.TokenAmount.profit} % ({stakingLang.days30[this.state.Language]})</div>
                                    </div>
                                </div>
                            </div>*/}

                            <div class="row" style={{width: '100%'}}>
                                <div class="col-md-6 col-sm-12">
                                    <div class="package-area2">
                                        <div className="package-ttl2" style={{width: '162px'}}>
                                            <img className="package-img2" src={ArnoGold} /> {stakingLang.staking[this.state.Language]}
                                        </div>

                                        <div className="package-price2">
                                            <input className="SumInputDash2" type="text" value={this.state.deposit ? this.state.deposit : ''} name="deposit" placeholder={stakingLang.enter_amount[this.state.Language]} onChange={this.ChangeElement}/>
                                            <div className="package-price-text2">$ARTY</div>
                                            <div class="help-sum">
                                                {this.state.deposit > this.props.session.Balance && `${stakingLang.maximum[this.state.Language]} ${this.props.session.Balance.toFixed(3)} $ARTY`}
                                                {this.state.deposit > 10000 && <><br/> {stakingLang.maximum[this.state.Language]} 10,000 $ARTY</>}
                                            </div>
                                            {this.state.deposit && this.state.deposit < 1000 ?
                                                (<div class="help-sum">{stakingLang.minimum[this.state.Language]} 1000 $ARTY</div>) : (
                                                    <></>
                                                )
                                            }
                                        </div>

                                        <div className="custom-separator" style={{'width': '45%'}}></div>

                                        <div className="payment-type-area" style={{width: '150px', 'white-space': 'nowrap'}}>
                                            <div className="PaymentCoin2">
                                                {stakingLang.maximum_available[this.state.Language]}
                                            </div>
                                        </div>
                                        <div className="PaymentCoinSum2">
                                            {/*{AvailableTokens}*/}{this.props.session.Balance} $ARTY
                                        </div> 
                                        <div className="total-arno" style={{marginTop: 15}}>
                                            {stakingLang.total_profit[this.state.Language]}
                                        </div>
                                        <ul class="list-package" style={{width: "265px"}}>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.afterYear1[this.state.Language]} {this.state.deposit > 10000 ? 10000 * 1.25 : this.state.deposit * 1.25} $ARTY
                                            </li>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.afterYear2[this.state.Language]} {this.state.deposit > 10000 ? 10000 * 2 : this.state.deposit * 2} $ARTY
                                            </li>
                                            <li class="mb-3">
                                                <img className="check-img" src={check}/> {stakingLang.afterYear3[this.state.Language]} {this.state.deposit > 10000 ? 10000 * 4 : this.state.deposit * 4} $ARTY
                                            </li>
                                        </ul>
                                           
                                        {CanSteak ? (
                                            <Mutation mutation={CREATE_STEAKING} variables={{ 
                                                email: this.props.session.email, 
                                                name: this.props.session.Name, 
                                                surname: this.props.session.Surname, 
                                                deposit: +this.state.deposit 
                                            }} >
                                                {(createSteaking, { data, loading, error }) => {
                                                    return (
                                                        <>           
                                                            {/* <div className="package-but buy-botton" onClick={event => self.createSteakingEvent(event, createSteaking)}>
                                                                {stakingLang.stake_arty[this.state.Language]}
                                                            </div> */}
                                                        </>
                                                    )
                                                }}
                                            </Mutation>
                                        ) : (
                                            <div className="package-but-disable buy-botton">
                                                {stakingLang.stake_arty[this.state.Language]}
                                            </div>
                                        )}
                                        {/*
                                        <div className="package-but-disable buy-botton" onMouseOver={this.handleMouseIn.bind(this)} onMouseOut={this.handleMouseOut.bind(this)}>
                                            <div className="tooltipArea" style={tooltipStyle}>{stakingLang.stake_not_available[this.state.Language]}</div>
                                            {stakingLang.stake_arty[this.state.Language]}
                                        </div>
                                        */}
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="package-area2">
                                        <div className="total-arno">
                                            {stakingLang.tool[this.state.Language]}
                                        </div>
                                        <div className="total-arno">
                                            {stakingLang.need[this.state.Language]}
                                        </div>
                                        <ol class="list-package" style={{'width': '85%'}}>
                                            <li class="mb-3">
                                                {stakingLang.info_list1[this.state.Language]}
                                            </li>
                                            <li class="mb-3">
                                                {stakingLang.info_list2[this.state.Language]}
                                            </li>
                                            <li class="mb-3">
                                                {stakingLang.info_list3[this.state.Language]}
                                            </li>
                                            <li class="mb-3">
                                                {stakingLang.info_list4[this.state.Language]}
                                            </li>
                                            <li class="mb-3">
                                                {stakingLang.info_list5[this.state.Language]}
                                            </li>
                                        </ol>
                                        <div className="total-arno">
                                            {stakingLang.info_list7[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            
                           
                        </div>

                    </div>
                </div>
                
                <div className="StandartPartMain">
                    <div className="PersonalPageMainPersonalInformation StandartBigElement">
                        <div class="IndexMainElementIn">
                            <div class="StandartElementTitle" style={{textTransform: 'uppercase'}}>{stakingLang.history[this.state.Language]}</div>
                            <div class="StandartElementTopBorder"></div>
                        </div>

                        <div className="MarketPageWithdrawalMoneyIn MarketPageWithdrawalMoneyIn02">
                            
                        <div className="row width98p">
                            <div className="col-md-12">
                                <div className="CertTable mt10px only-white padding-table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>{stakingLang.depo_arty[this.state.Language]}</th>
                                                <th>{stakingLang.date_start[this.state.Language]}</th>
                                                <th>{stakingLang.status[this.state.Language]}</th>

                                                {/*<th>{stakingLang.cost[this.state.Language]}</th>
                                                <th>{stakingLang.profit[this.state.Language]}</th>
                                                <th>{stakingLang.profit[this.state.Language]} %</th>
                                                <th>{stakingLang.days_passed[this.state.Language]}</th>
                                                <th>{stakingLang.date_end[this.state.Language]}</th>*/}
                                                <th>{stakingLang.paymentYear1[this.state.Language]}</th>
                                                <th>{stakingLang.paymentYear2[this.state.Language]}</th>
                                                <th>{stakingLang.paymentYear3[this.state.Language]}</th>
                                                <th>{stakingLang.actions[this.state.Language]}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        
                                            <Query query = {GET_USER_STEAKING} variables={{ email: this.props.session.email }}>
                                                {({ data, loading, error}) => {
                                                    if (loading) return <div>loading</div>;
                                                    if (error) {
                                                        window.open(`${process.env.SITE_ADDRESS}/noauth/`, '_top'); 
                                                        return <div>error</div>;
                                                    }

                                                    const AllSteaking = data.getUserSteaking.map( function(steak, i) {
                                                        const CurrentDate = new Date();
                                                        
                                                        if (steak.close) { status = 'Closed' }
                                                        // let steakUrl = 'https://launch.artyfact.game/staking/' + steak._id;
                                                        let DateStart = steak.DateStart;
                                                        //console.log(new Date(+DateStart));
                                                        let DateForm = new Date(+DateStart);
                                                        
                                                        //let from = DateForm.search('GMT'); 
                                                        let NewDateForm = DateForm.toLocaleDateString("en-US");
                                                        let StartDepo = steak.depositStart ? steak.depositStart : steak.deposit;

                                                        let DateFormEnd = new Date(+steak.DateEnd);
                                                        let status = CurrentDate > DateFormEnd ? 'Available' : 'Active';
                                                        let end = DateFormEnd.toLocaleDateString("en-US"); 
                                                        //let NewDateFormEnd = DateFormEnd.substring(0,end);
                                                        let DateOn1 = new Date(+DateStart + 365 * 86400 * 1000);
                                                        let DateOn2 = new Date(+DateStart + 2 * 365 * 86400 * 1000);
                                                        let DateOn3 = new Date(+DateStart + 3 * 365 * 86400 * 1000);
                                                        return (
                                                            <tr>
                                                                <td>{steak.deposit.toFixed(2)} $ARTY</td>
                                                                <td>{NewDateForm}</td>
                                                                <td>{!steak.close ? status : "Closed"}</td>
                                                                <td>{steak.deposit.toFixed(2) * 1.25} $ARTY on {DateOn1.toLocaleDateString("en-US")}</td>
                                                                <td>{steak.deposit.toFixed(2) * 2} $ARTY on {DateOn2.toLocaleDateString("en-US")}</td>
                                                                <td>{steak.deposit.toFixed(2) * 4} $ARTY on {DateOn3.toLocaleDateString("en-US")}</td>

                                                                {/*<td>{steak.Cost.toFixed(3)}</td>
                                                                <td>{(steak.Cost - StartDepo).toFixed(3)}</td>
                                                                <td>{(steak.Profit * 100).toFixed(2)}</td>
                                                                <td>{steak.DaysPassed}</td>
                                                                <td>{NewDateFormEnd}</td>*/}

                                                                <td>{!steak.close && <a onClick={event => {self.OpenModal(event, steak._id)}} style={{color: "#ffffff", cursor: "pointer"}}>Close</a>}</td>
                                                            </tr>
                                                        )
                                                    });

                                                    return (
                                                        <>
                                                            {data.getUserSteaking.length > 0 ? (
                                                                <>{AllSteaking}</>
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="8" className="text-center">{stakingLang.not_data[this.state.Language]}</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    )
                                                }
                                                }
                                            </Query>
                                        
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>

            </div>

            <div className="Modal" style={{ display: this.state.ModalShow ? 'block' : 'none' }}>
                <div class="Modal-dialog" style={{ 'max-width': '520px' }}>
                    <div className="Modal-content">
                        <div className="Modal-header">
                            <div className="closeModal" style={{ right: '-8px' }} onClick={this.CloseModal}>×</div>
                            {stakingLang.modal_ttl[this.state.Language]}
                        </div>
                        <div className="Modal-body">
                            {this.state.steakid &&
                                <Query query={GET_CURRENT_STEAKING} variables={{ steakid: this.state.steakid }}>
                                    {({ data, loading, error }) => {
                                        if (loading) return <div>loading</div>;
                                        if (error) return <div>error</div>;

                                        // console.log(data.getCurrentSteaking);

                                        return <ModalSteak Steak={data.getCurrentSteaking} session={this.props.session} refetch={this.props.refetch}/>
                                    }}
                                </Query>
                            }
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}

export default Steaking